import { render, staticRenderFns } from "./ImportantMessage.vue?vue&type=template&id=b908e246&scoped=true&"
var script = {}
import style0 from "./ImportantMessage.vue?vue&type=style&index=0&id=b908e246&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b908e246",
  null
  
)

export default component.exports